import Button from './Button'
import { ButtonProps } from './types'

export function ButtonClear({ children, ...rest }: ButtonProps): React.ReactElement {
  return (
    <Button
      className={
        'focus:ring-8 lg:focus:ring-gray-light ' +
        'text-purple lg:hover:text-purple-dark ' +
        'lg:disabled:text-purple focus:text-purple-focus'
      }
      {...rest}
    >
      {children}
    </Button>
  )
}
